import { h } from 'vue'
import VSelect from 'vue-select'
import HighlightedText from './HighlightedText.vue'
import { matchesQuery } from '../../utils/highlight'

// Global `v-select` (Aşama 4.1): vue-select 4 üstünde vue-select 3 sözleşmesi. Kaynak
// Estesoft.App/clientapp/src/components/shared/CompatVSelect.js; tüketiciler (43 dosya) değişmez.
// Vega farkları: clientapp'in "mobilde arama kapalı" varsayılanı alınmadı (Vega'da arama her
// cihazda açık kalır; `searchable` olduğu gibi pakete geçer) ve kullanılmayan `optionSuffix` yok.
// Görünüm assets/css/select.css.

// Filtre vurguyla aynı eşleştiriciyi kullanır (Türkçe ı/İ ve aksan duyarsız). Paketin varsayılanı
// `toLocaleLowerCase().indexOf` idi: "istanbul" yazınca "İstanbul" düşüyor, filtrenin bıraktığı satır
// vurgusuz kalabiliyordu.
const filterBy = (option, label, search) => matchesQuery(label, search)

export default {
  name: 'CompatVSelect',
  inheritAttrs: false,
  props: {
    modelValue: {
      default: undefined
    },
    value: {
      default: undefined
    }
  },
  // vue-select 3 `change` yaymıyordu; burada yutulur ki kökteki native change sızmasın.
  emits: ['update:modelValue', 'input', 'change'],
  methods: {
    updateValue(value) {
      this.$emit('update:modelValue', value)
      this.$emit('input', value)
    },
    clearSelection() {
      this.$refs.select.clearSelection()
    },
    // Aranan parça listede işaretlenir (clientapp gibi). Tüketici kendi `option` slot'unu verdiyse
    // ona dokunulmaz.
    renderHighlightedOption(option) {
      const select = this.$refs.select

      if (!select)
        return []

      return [h(HighlightedText, {
        text: select.getOptionLabel(option),
        // vue-select'in arama metni kendi reaktif verisidir; slot çocuğun render'ında okunur.
        term: select.search
      })]
    }
  },
  render() {
    const modelValue = this.modelValue === undefined
      ? this.value
      : this.modelValue

    const slots = this.$slots.option
      ? { ...this.$slots }
      : { ...this.$slots, option: this.renderHighlightedOption }

    // Paketin boş liste metni İngilizce ("Sorry, no matching options."); slot vermeyen tüketicilere çeviri.
    if (!slots['no-options'])
      slots['no-options'] = () => this.$t('NoMatchingOptionsMessage')

    return h(VSelect, {
      filterBy,
      ...this.$attrs,
      ref: 'select',
      modelValue,
      'onUpdate:modelValue': this.updateValue
    }, slots)
  }
}
